import { all, takeLatest, put, fork, call } from 'redux-saga/effects';
import actions from './actions';
import * as multipleAnswerServices from '@iso/services/reading/multipleAnswer';

//#region CRUD
export function* getMultipleAnswer() {
	yield takeLatest(actions.GET_MULTIPLE_ANSWER, function* ({ payload }) {
		const { model } = payload;
		try {
			var response = yield call(multipleAnswerServices.getAPIMultipleAnswer, model);
			if (response.data.success === true) {
				var data = response.data.data.data;
				var totalItems = response.data.data.total;
				yield put({
					type: actions.GET_MULTIPLE_ANSWER_SUCCESS,
					payload: { data, totalItems },
				});
			}
		} catch (e) {
			yield put({
				type: actions.READING_LOADING_FALSE,
			});
		}
	});
}

export function* getMultipleAnswerDetail() {
	yield takeLatest(actions.GET_MULTIPLE_ANSWER_DETAIL, function* ({ payload }) {
		const { id } = payload;
		try {
			var response = yield call(multipleAnswerServices.getAPIMultipleAnswerDetail, id);
			if (response.data.success === true) {
				var data = response.data.data;
				yield put({
					type: actions.GET_MULTIPLE_ANSWER_DETAIL_SUCCESS,
					payload: { data },
				});
			}
		} catch (e) {
			yield put({
				type: actions.READING_LOADING_FALSE,
			});
		}
	})
}

// export function* getReadAloudDetail() {
// 	yield takeLatest(actions.GET_READ_ALOUD_DETAIL, function* ({ payload }) {
// 		const { id } = payload;
// 		try {
// 			var response = yield call(blanksDropDownServices.getReadAloudDetail, id);
// 			if (response.data.success === true) {
// 				var data = response.data.data;
// 				yield put({
// 					type: actions.GET_DROP_DOWN_DETAIL_SUCCESS,
// 					payload: { data },
// 				});
// 			}
// 		} catch (e) {
// 			yield put({
// 				type: actions.READING_LOADING_FALSE,
// 			});
// 		}
// 	});
// }

// export function* createQuesReadAloud() {
// 	yield takeLatest(actions.CREATE_NEW_DROP_DOWN, function* ({ payload, cbSuccess, cbError }) {
// 		const { model } = payload;
// 		try {
// 			var response = yield call(blanksDropDownServices.createQuesReadAloud, model);
// 			if (response.data.success === true) {
// 				yield cbSuccess();
// 			}
// 		} catch (e) {
// 			if (e.response && e.response.data) yield cbError(e.response.data.ErrorMessage);
// 			else yield cbError();
// 		}
// 	});
// }

// export function* updateReadAloudDetail() {
// 	yield takeLatest(actions.UPDATE_DROP_DOWN_DETAIL, function* ({ payload, cbSuccess, cbError }) {
// 		const { model } = payload;
// 		try {
// 			var response = yield call(blanksDropDownServices.updateReadAloudDetail, model);
// 			if (response.data.success === true) {
// 				yield cbSuccess();
// 			}
// 		} catch (e) {
// 			if (e.response && e.response.data) yield cbError(e.response.data.ErrorMessage);
// 			else yield cbError();
// 		}
// 	});
// }

// export function* deleteReadAloud() {
// 	yield takeLatest(actions.DELETE_DROP_DOWN, function* ({ payload, cbSuccess, cbError }) {
// 		const { id } = payload;
// 		try {
// 			var response = yield call(blanksDropDownServices.deleteReadAloud, id);
// 			if (response.data.success === true) {
// 				yield cbSuccess();
// 			}
// 		} catch (e) {
// 			if (e.response && e.response.data) yield cbError(e.response.data.ErrorMessage);
// 			else yield cbError();
// 		}
// 	});
// }

// export default function* rootSaga() {
// 	yield all([fork(getMultipleAnswer), fork(getReadAloudDetail), fork(createQuesReadAloud), fork(updateReadAloudDetail), fork(deleteReadAloud)]);
// }

export default function* rootSaga() {
	yield all([fork(getMultipleAnswer), fork(getMultipleAnswerDetail)]);
}
